import React from 'react';
import { Grid, Skeleton, Box } from '@mui/material';

/**
 * Skeleton KPI row (design-review #27, #51).
 */
const DashboardLoadingState = ({ count = 4, testId = 'dashboard-loading-state' }) => (
    <Box data-testid={testId}>
        <Grid container spacing={2}>
            {Array.from({ length: count }).map((_, index) => (
                <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
                    <Skeleton variant="rounded" height={120} />
                </Grid>
            ))}
        </Grid>
    </Box>
);

export default DashboardLoadingState;
